export default {
  rounded: {
    borderRadius: '4px',
  },
  boxShadowCard: {
    // -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.15);
    // -moz-box-shadow: 0 1px 3px rgba(0,0,0,.15);
    boxShadow: '0 1px 3px rgba(0,0,0,.15)'
  },
  circleCounter: {
    fontSize: "1.5em",
  },
  titleText: {
    marginRight: '5px',
  },
  itemHeader: {
    display: 'flex',
    width: '100%',
  },
  itemHeaderTitle: {
    left: 0,
    width: '60%',
    flex: '0 0 55%',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    cursor: 'pointer',
  },
  itemHeaderInfo: {
    fontSize: '0.8em',
  },
  itemHeaderInfoDiv: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
  },
};



// WEBPACK FOOTER //
// ./src/containers/Dashboard/styles.js